import Grid from 'components/core/Grid';
import { FormikAppTextField } from 'components/formik/core/FormikAppTextField/FormikAppTextField';

interface Props {
  formikPrefix: string;
  isCompany: boolean;
}

export const AccountOwnerName = ({ formikPrefix, isCompany }: Props) => {
  return (
    <>
      {isCompany ? (
        <Grid item xs={12}>
          <FormikAppTextField name={`${formikPrefix}COMPANY_NAME`} label="Company Name" />
        </Grid>
      ) : (
        <>
          <Grid item sm={6} xs={12}>
            <FormikAppTextField name={`${formikPrefix}FIRST_NAME`} label="First Name" />
          </Grid>
          <Grid item sm={6} xs={12}>
            <FormikAppTextField name={`${formikPrefix}LAST_NAME`} label="Last Name" />
          </Grid>
        </>
      )}
    </>
  );
};
